import * as Yup from 'yup';
import { getUserShape } from 'validators/Common/baseUserValidator';

export class UpdateMemberValidator {
  public get schema() {
    return Yup.object().shape({
      userId: Yup.number()
        .typeError('Usuário inválido')
        .required('Usuário é obrigatório'),

      user: Yup.object().shape({
        ...getUserShape(),
        password: Yup.string().notRequired(),
      }),
    });
  }
}